export const formatLeadTime = (leadTime, t) => {
  if (!leadTime) return "-";

  const { type, value } = leadTime;
  const isPlural = value > 1;

  switch (type) {
    case "day":
      return isPlural
        ? t("lead_time.days", { value })
        : t("lead_time.day", { value });

    case "month":
      return isPlural
        ? t("lead_time.months", { value })
        : t("lead_time.month", { value });

    case "year":
      return isPlural
        ? t("lead_time.years", { value })
        : t("lead_time.year", { value });

    case "month_end":
      return isPlural
        ? t("lead_time.next_months_end", { value })
        : t("lead_time.next_month_end", { value });

    case "year_end":
      return isPlural
        ? t("lead_time.next_years_end", { value })
        : t("lead_time.next_year_end", { value });

    default:
      return "-";
  }
};